// extracted by mini-css-extract-plugin
export default {"header":"recurring-services_header__tWdVn","button":"recurring-services_button__q7bOh","headerRow":"recurring-services_headerRow__sqccy","link":"recurring-services_link__cF0jM"};